/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tutor_Rooterror_Subtitle1Inputs */

const en_tutor_rooterror_subtitle1 = /** @type {(inputs: Tutor_Rooterror_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again`)
};

const fr_tutor_rooterror_subtitle1 = /** @type {(inputs: Tutor_Rooterror_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez réessayer`)
};

/**
* | output |
* | --- |
* | "Please try again" |
*
* @param {Tutor_Rooterror_Subtitle1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const tutor_rooterror_subtitle1 = /** @type {((inputs?: Tutor_Rooterror_Subtitle1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tutor_Rooterror_Subtitle1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tutor_rooterror_subtitle1(inputs)
	return fr_tutor_rooterror_subtitle1(inputs)
});
export { tutor_rooterror_subtitle1 as "tutor_rootError_subtitle" }